export default __webpack_public_path__ + "static/media/condizioni_generali_di_acquisto_Fincantieri_si_ITA.120f70f5.pdf";